var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 15.8342H11.6666V5.00088L16.9949 7.28442C17.3013 7.41574 17.5 7.71702 17.5 8.05038V15.8342H19.1666V17.5009H0.833313V15.8342H2.49998V4.7091C2.49998 4.37979 2.69392 4.08135 2.99486 3.9476L9.41406 1.09461C9.6244 1.00115 9.87065 1.09585 9.96406 1.30614C9.98773 1.35941 9.99998 1.41706 9.99998 1.47536V15.8342Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInfo);
export default __webpack_public_path__ + "static/media/company-info.4bd2c3844b91b4a55a0e31ef6e6517f5.svg";
export { ForwardRef as ReactComponent };